import React, { useState } from 'react'
import {motion} from 'framer-motion'
import copy from 'copy-to-clipboard';
import { ReactComponent as Facebook} from '../../assets/images/facebook.svg'
import { ReactComponent as Link}  from '../../assets/images/link.svg'
// import wechat from '../../assets/images/wechat.svg'
// import weibo from '../../assets/images/weibo.svg'
import { ReactComponent as X}  from '../../assets/images/x.svg'
import './index.scss'

const share_title = "AI or Not – Find the real Song paintings"
const theHref = window.location.href.split('#')[0];
const Result = (props)=>{
    const [copyText,setCopyText] = useState('')
    const handleTouchStart = (event)=>{
        event.preventDefault();
        document.querySelector('.J_copyTips').setAttribute('style',"display:inline-block");
        setCopyText(theHref);
    }
    const handleTouchEnd = (event)=>{
        event.preventDefault();
        document.querySelector('.J_copyTips').setAttribute('style',"display:none");
        copy(theHref);
    }
    const handleClick = (event) => {
        event.preventDefault();
        copy(theHref);
        setCopyText(theHref);
        setTimeout(() => {
          setCopyText("");
        }, 1000);
      }
    return (
      <motion.div>
        <div className="result-wraper">
          <div className="result-title">Game Over</div>
          <div className="result-score-tips">Score:</div>
          <div className="result-score-number">
            <span>{props.totalScore}</span>
            <span>{` Point${props.totalScore != 1 ? "s" : ""}`}</span>
          </div>
          <span
            className="result-play-again"
            onClick={props.playAgain && props.playAgain}
          >
            Play Again
          </span>
          <div className="result-models">
            <div className="">
              {" "}
              <a
                href="https://news.cgtn.com/event/2022/The-Song-Painted/index.html"
                target="_blank"
              >
                Experience "The Song, Painted"
              </a>
            </div>
            <div className="">
              {" "}
              <a
                href="https://civitai.com/models/968377/chinese-painting-in-the-song-dynasty-lora"
                target="_blank"
              >
                Try the generative model
              </a>
            </div>
            <div className="">
              {" "}
              <a
                href="https://news.cgtn.com/event/2025/ai-or-not/movie/index.html"
                target="_blank"
              >
                Try AI or Not - Movie Screenshots
              </a>
            </div>
            <div className=''>
              <a
                href="https://news.cgtn.com/event/2025/ai-or-not/pet/index.html"
                target="_blank"
              >
                Try AI or Not - Pets
              </a>
            </div>
          </div>
          <div className="result-share">
            <span>Share to:</span>
            <div>
              <a
                target="_blank"
                href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                  theHref
                )}&display=popup&app_id=723054267828678`}
              >
                <Facebook />
              </a>
              <a
                target="_blank"
                className='share-x'
                href={`https://twitter.com/intent/tweet?text=${share_title}&url=${encodeURIComponent(
                  theHref
                )}&via=cgtnofficial"`}
              >
                <X />
              </a>
              {/* <a target="_blank" href={`http://service.weibo.com/share/share.php?appkey=4122844478&title=${share_title}&url=${encodeURIComponent(theHref)}&pic=&searchPic=true&style=simple`}><img src={weibo}/></a>
                        <a target="_blank"><img src={wechat}/></a> */}
              <a
                className="share_link"
                onClick={handleClick}
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
              >
                <Link />
                <span className="J_copyTips">
                  {copyText ? "Copied" : "Copy to clipboard"}
                </span>
              </a>
            </div>
          </div>
        </div>
      </motion.div>
    );
}

export default Result